function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 90,
  height: 60
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#D3D5E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.7024 34.4106C58.2881 33.594 56.6955 33.3573 55.1179 33.3022C53.7943 33.256 51.8196 32.4079 51.8196 30.0001C51.8196 28.2062 53.2739 26.7624 55.1186 26.698C56.696 26.6429 58.2885 26.406 59.7024 25.5896C60.9725 24.8564 62.0271 23.8017 62.7604 22.5317C63.4936 21.2616 63.8797 19.8209 63.8797 18.3544C63.8796 16.8879 63.4936 15.4472 62.7603 14.1772C62.0271 12.9071 60.9724 11.8525 59.7023 11.1192C58.4323 10.386 56.9916 9.99997 55.525 10C54.0585 10 52.6178 10.3861 51.3478 11.1194C50.0778 11.8527 49.0231 12.9074 48.2899 14.1774C47.5567 15.4475 47.1707 16.8882 47.1708 18.3547C47.1708 19.9734 47.7465 21.463 48.4811 22.8445C49.0989 24.0065 49.4115 26.1632 47.2925 27.3865C45.7162 28.2966 43.749 27.7203 42.7664 26.1478C41.9364 24.8195 40.9344 23.575 39.5316 22.7649C38.2616 22.0317 36.8209 21.6456 35.3544 21.6456C33.8879 21.6456 32.4473 22.0317 31.1772 22.7649C29.9072 23.4982 28.8525 24.5528 28.1193 25.8228C27.386 27.0929 27 28.5335 27 30.0001C27 31.4666 27.386 32.9072 28.1193 34.1773C28.8525 35.4473 29.9072 36.5019 31.1772 37.2352C32.4473 37.9684 33.8879 38.3545 35.3544 38.3545C36.8209 38.3545 38.2616 37.9684 39.5316 37.2352C40.934 36.4254 41.9361 35.1817 42.7655 33.8543C43.4467 32.7642 45.1478 31.3748 47.2924 32.6139C48.8663 33.5232 49.3528 35.5156 48.4803 37.1567C47.7458 38.538 47.1709 40.0273 47.1709 41.6457C47.1709 43.1122 47.5569 44.5528 48.2901 45.8228C49.0234 47.0929 50.078 48.1475 51.348 48.8807C52.6181 49.614 54.0587 50 55.5252 50C56.9917 50 58.4323 49.614 59.7024 48.8807C60.9724 48.1475 62.027 47.0929 62.7603 45.8228C63.4935 44.5528 63.8795 43.1122 63.8795 41.6457C63.8795 40.1792 63.4935 38.7385 62.7603 37.4685C62.027 36.1985 60.9724 35.1439 59.7024 34.4106Z",
  fill: "url(#paint0_linear)"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 37.4008,
  y1: 16.1384,
  x2: 65.1242,
  y2: 43.8617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AAE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006097"
})));

var SvgXrp = function SvgXrp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXrp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/XRP.457ef7ef.svg";
export { ForwardRef as ReactComponent };